export default function scriptsQuemSomos() {
  const swiperValores = new Swiper('.swiper-valores', {
    slidesPerView: 'auto',
    spaceBetween: 32,
    autoplay: {
      delay: 3000,
      disableOnInteractio: false,
      // pauseOnMouseEnter: true
    },
    breakpoints: {
      1200: {
        slidesPerView: 6,
        spaceBetween: 32,
      },
    },
  });
}
